import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import Marquee from 'react-fast-marquee';
import { SPLAT } from '../../../../config/constants/images';
import { PPC_SIGN_UP } from '../../../../config/constants/ppc';
import useCheckMobile from '../../../../helpers/checkMobile';
import ThemeContext from '../../../../providers/ThemeProvider';
import TrustBox from '../../../deal/TrustBox';
import InputDropdown from './InputDropdown';

const WelcomePageLayouts = ({
  variant,
  list,
  subTitle,
  botField,
  buttonText,
  handleHoneyPotField,
  redirectUrl,
  isAuthenticated,
  isMobile,
  setShowModal,
  subscribe,
  email,
  changeEmail,
  locationAux,
  onChangeAction,
  showError,
  showErrorForLocation,
  showKickboxError,
  suggestedMail,
  updatedList,
  mobileImageUrl,
  desktopImageUrl,
}) => {
  const theme = useContext(ThemeContext);
  const imgSource = theme.images.headerlogo;
  const complianceText = PPC_SIGN_UP(buttonText)[process.env.NEXT_PUBLIC_BRAND];

  const renderLayout = () => {
    switch (variant) {
      case 'b':
        return (
          <>
            <div className="header-welcome-page">
              <img alt="" height="auto" src={imgSource} width="130px" />
              <TrustBox isWelcomePage={variant} />
            </div>
            {isMobile ? (
              <img alt="" className="welcome-page-img" src={desktopImageUrl} />
            ) : (
              <div className="responsive-img-welcome-page" />
            )}
            {subTitle && (
              <Marquee
                className="subtitle-welcome-page"
                gradient={false}
                speed={50}
              >
                {subTitle.toLowerCase()}
              </Marquee>
            )}
            <InputDropdown
              changeEmail={changeEmail}
              email={email}
              locationAux={locationAux}
              onChangeAction={onChangeAction}
              showError={showError}
              showErrorForLocation={showErrorForLocation}
              showKickboxError={showKickboxError}
              suggestedMail={suggestedMail}
              updatedList={updatedList}
              variant={variant}
            />
            <label style={{ display: 'none' }}>
              {botField}
              <input
                aria-label="Leave blank"
                autoComplete="off"
                onChange={handleHoneyPotField}
                type="text"
              />
            </label>
            <button className="btn-welcome" onClick={subscribe}>
              {buttonText}
            </button>
            <div className="compliance-text">
              <div
                className="compliance-content"
                dangerouslySetInnerHTML={{
                  __html: complianceText,
                }}
              />
            </div>
          </>
        );
      case 'c':
        return (
          <>
            <div className="header-welcome-page">
              <img alt="" height="auto" src={imgSource} width="130px" />
              <TrustBox isWelcomePage={variant} />
            </div>
            {isMobile ? (
              <img alt="" className="welcome-page-img" src={desktopImageUrl} />
            ) : (
              <div className="responsive-img-welcome-page" />
            )}
            {subTitle && <p className="subtitle-welcome-page">{subTitle}</p>}
            <InputDropdown
              changeEmail={changeEmail}
              email={email}
              locationAux={locationAux}
              onChangeAction={onChangeAction}
              showError={showError}
              showErrorForLocation={showErrorForLocation}
              showKickboxError={showKickboxError}
              suggestedMail={suggestedMail}
              updatedList={updatedList}
              variant={variant}
            />
            <label style={{ display: 'none' }}>
              {botField}
              <input
                aria-label="Leave blank"
                autoComplete="off"
                onChange={handleHoneyPotField}
                type="text"
              />
            </label>
            <button className="btn-welcome" onClick={subscribe}>
              {buttonText}
            </button>
            <div className="compliance-text">
              <div
                className="compliance-content"
                dangerouslySetInnerHTML={{
                  __html: complianceText,
                }}
              />
            </div>
          </>
        );
      case 'd':
        return (
          <>
            <div className="header-welcome-page">
              <img alt="" height="auto" src={imgSource} width="130px" />
            </div>
            <div className="splat-content">
              <span className="splat-text-welcome-page">SAVE OVER 80%!</span>
            </div>
            {isMobile ? (
              <img alt="" className="welcome-page-img" src={desktopImageUrl} />
            ) : (
              <div className="responsive-img-welcome-page" />
            )}
            {subTitle && (
              <p className="subtitle-welcome-page">{subTitle.toUpperCase()}</p>
            )}
            <InputDropdown
              changeEmail={changeEmail}
              email={email}
              locationAux={locationAux}
              onChangeAction={onChangeAction}
              showError={showError}
              showErrorForLocation={showErrorForLocation}
              showKickboxError={showKickboxError}
              suggestedMail={suggestedMail}
              updatedList={updatedList}
              variant={variant}
            />
            <label style={{ display: 'none' }}>
              {botField}
              <input
                aria-label="Leave blank"
                autoComplete="off"
                onChange={handleHoneyPotField}
                type="text"
              />
            </label>
            <button className="btn-welcome" onClick={subscribe}>
              {buttonText}
            </button>
            <TrustBox isWelcomePage={variant} />

            <div className="compliance-text">
              <div
                className="compliance-content"
                dangerouslySetInnerHTML={{
                  __html: complianceText,
                }}
              />
            </div>
          </>
        );
      case 'e':
        return (
          <>
            <div className="header-welcome-page">
              <img alt="" height="auto" src={imgSource} width="130px" />

              <TrustBox isWelcomePage={variant} />
            </div>
            {isMobile ? (
              <img alt="" className="welcome-page-img" src={desktopImageUrl} />
            ) : (
              <div className="responsive-img-welcome-page" />
            )}
            {subTitle && (
              <p className="subtitle-welcome-page">{subTitle.toUpperCase()}</p>
            )}
            <div className="container-welcome-page-bottom">
              <InputDropdown
                changeEmail={changeEmail}
                email={email}
                locationAux={locationAux}
                onChangeAction={onChangeAction}
                showError={showError}
                showErrorForLocation={showErrorForLocation}
                showKickboxError={showKickboxError}
                suggestedMail={suggestedMail}
                updatedList={updatedList}
                variant={variant}
              />
              <label style={{ display: 'none' }}>
                {botField}
                <input
                  aria-label="Leave blank"
                  autoComplete="off"
                  onChange={handleHoneyPotField}
                  type="text"
                />
              </label>
              <button className="btn-welcome" onClick={subscribe}>
                {buttonText}
              </button>
              <div className="compliance-text">
                <div
                  className="compliance-content"
                  dangerouslySetInnerHTML={{
                    __html: complianceText,
                  }}
                />
              </div>
            </div>
          </>
        );
      case 'f':
        return (
          <>
            <div className="header-welcome-page">
              <img alt="" height="auto" src={imgSource} width="130px" />
              <TrustBox isWelcomePage={variant} />
            </div>
            <img alt="" className="welcome-page-img" src={desktopImageUrl} />
            {subTitle && (
              <Marquee
                className="subtitle-welcome-page"
                gradient={false}
                speed={50}
              >
                {subTitle.toLowerCase()}
              </Marquee>
            )}
            <InputDropdown
              changeEmail={changeEmail}
              email={email}
              locationAux={locationAux}
              onChangeAction={onChangeAction}
              showError={showError}
              showErrorForLocation={showErrorForLocation}
              showKickboxError={showKickboxError}
              suggestedMail={suggestedMail}
              updatedList={updatedList}
              variant={variant}
            />
            <label style={{ display: 'none' }}>
              {botField}
              <input
                aria-label="Leave blank"
                autoComplete="off"
                onChange={handleHoneyPotField}
                type="text"
              />
            </label>
            <button className="btn-welcome" onClick={subscribe}>
              {buttonText}
            </button>
            <div className="compliance-text">
              <div
                className="compliance-content"
                dangerouslySetInnerHTML={{
                  __html: complianceText,
                }}
              />
            </div>
          </>
        );
      default:
        return null; // Default case should not be reached as Subscriber handles 'a' or no cookie
    }
  };

  return (
    <div className="container-welcome-page" theme={theme} variant={variant}>
      {renderLayout()}
      <style jsx>{`
        :global(.container-welcome-page) {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          background: ${
            variant === 'e'
              ? 'linear-gradient(to bottom, white 60%, #eb008c 60%)'
              : '#fff'
          };
          color: ${variant === 'd' || variant === 'e' ? '#fff' : '#000'};
        }

        :global(.header-welcome-page) {
          display: flex;
          justify-content: space-between;
          width: 95%;
          align-items: center;
          background: #fff;
          padding-bottom: 4px;
        }

        :global(.subtitle-welcome-page) {
          font-size: ${isMobile ? '16px' : '20px'};
          text-align: center;
          margin: 0px;
          text-transform: ${
            variant === 'd' || variant === 'e' ? 'uppercase' : 'capitalize'
          };
          background-color: ${theme.colors.buttonsecondary};
          color: #fff;
          padding: 16px;
          width: 100%;
          margin-bottom: 0px;
          padding-bottom: ${variant === 'b' ? '22px' : '16px'};
           font-weight: bold;
        }

        :global(.btn-welcome) {
            background-color: ${
              variant === 'b' || variant === 'f'
                ? theme.colors.buttonsecondary
                : theme.colors.dealviewbutton
            };
            color: #fff;
            border-radius: ${
              variant === 'b' || variant === 'f' ? '14px' : '50px'
            };
            padding: 15px 30px;
            border: none;
            font-size: 18px;
            font-weight: bold;
            cursor: pointer;
            margin: 20px 0;
            width: 40%;
            text-transform: uppercase;
            animation: fadeUp 1s ease-out;  
            transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out; /* Micro-interaction */
        }

        :global(.btn-welcome):hover {
            transform: ${variant === 'b' ? `scale(1.05)` : `scale(1)`}; 
            box-shadow: ${
              variant === 'b' ? `0px 4px 15px rgba(0, 0, 0, 0.2)` : `none`
            }; 
        }

        :global(.welcome-page-img){
                width : 100%;
                object-fit: cover;
                height: 45vh;
                
        }

        :global(.btn-welcome):active {
            transform: scale(0.98); 
            box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1); 
        }

        @keyframes fadeUp {
            0% {
                opacity: 0;
                transform: translateY(20px);
            }
            100% {
                opacity: 1;
                transform: translateY(0);
            }
        }
                
        :global(.splat-text-welcome-page) {
            border-radius: ${
              variant === 'b' || variant === 'f' ? '14px' : '50px'
            };
            padding: 38px;
            position: relative;
            height: auto !important;
            display: block;
            text-align: center;
        }


        :global(.container-welcome-page-bottom) {
          background: ${theme.colors.buttonsecondary};
          margin: 0px;
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          height: 100%;
        }

        :global(.compliance-text) {
          color: ${({ variant }) =>
            variant === 'd' || variant === 'e' ? '#fff' : '#333'};
          font-size: ${variant === 'c' ? '10px' : '12px'};
          text-align: center;
          margin-top: 10px;
          padding-bottom: 80px;
        }
        :global(.responsive-img-welcome-page) {
          width: 100%;
          height: 65vh;
          object-fit: cover;
        }

        :global(.compliance-content) {
          color: ${variant === 'e' ? '#fff' : '#6b6b6b'};
          font-size: 16px;
          margin: ${variant === 'd' ? '10px' : '70px'} 10% 0px 10%;
        }
        :global(.splat-content) {
          position: absolute;
          right: 0%;
          top: 4%;
          width: 200px;
          height: 200px;
          z-index: 10;
          color: #fff;
          font-size: 22px;
          font-weight: bold;
          text-transform: uppercase;
          padding: 20px;
          border-radius: 8px;
          background: url(${SPLAT[process.env.NEXT_PUBLIC_BRAND || 'wowcher']})
            no-repeat;
          background-position: center;
          transform: rotate(10deg);
          animation: spinCoin 2s ease-out;
        }

            @keyframes spinCoin {
                0% {
                    transform: rotate(10deg) rotateY(0deg); 
                }
                100% {
                    transform: rotate(10deg) rotateY(360deg);
                }
            }
        }

        @media only screen and (min-width: ${theme.breakpoints.xlUp}) {
          :global(.responsive-img-welcome-page) {
             height: 45vh;
            background: url(${desktopImageUrl});
            background-size: 100% auto;
            background-position: center 45vh;
          }
        }

        @media only screen and (min-width: ${theme.breakpoints.mdUp}) {
          :global(.responsive-img-welcome-page) {
            background: url(${desktopImageUrl});
            background-size: 100% auto;
            background-position: center 65vh;
          }
        :global(.welcome-page-img){
                width : 100%;
            }
        }

        @media only screen and (max-width: ${theme.breakpoints.mdUp}) {
          :global(.splat-text-welcome-page-bottom) {
            border-radius: ${
              variant === 'b' || variant === 'f' ? '14px' : '50px'
            };
            padding: 18px;
            position: relative;
            height: auto !important;
            display: block;
            text-align: center;
          }
          :global(.responsive-img-welcome-page) {
                background: url(${mobileImageUrl});
                background-position: center center;
                background-size: cover;
                }
          :global(.splat-content) {
            font-size: 12px;
            top: 3em;
            right: 0%;
            width: 100px;
            height: 100px;
            padding: 8px;

          }
          :global(.splat-text-welcome-page) {
            border-radius: ${
              variant === 'b' || variant === 'f' ? '14px' : '50px'
            };
            padding: 18px;
            position: relative;
            height: auto !important;
            display: block;
            text-align: center;
          }
          :global(.compliance-content) {
            font-size: 12px;
            margin: 0px 1% 0px 1%;
        }

        :global(.subtitle-welcome-page) {
           font-size: 18px;
           font-weight: bold;
        }
        :global(.btn-welcome) {
            width: 70%;
        }
        :global(.welcome-page-img){
            height: 30vh;
            width : 100%;
        }
      `}</style>
    </div>
  );
};

WelcomePageLayouts.propTypes = {
  botField: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  changeEmail: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired,
  handleHoneyPotField: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool,
  isMobile: PropTypes.bool,
  list: PropTypes.array.isRequired,
  locationAux: PropTypes.string.isRequired,
  onChangeAction: PropTypes.func.isRequired,
  redirectUrl: PropTypes.string,
  setShowModal: PropTypes.func,
  showError: PropTypes.bool.isRequired,
  showErrorForLocation: PropTypes.bool.isRequired,
  showKickboxError: PropTypes.bool.isRequired,
  showSpinner: PropTypes.bool.isRequired,
  subTitle: PropTypes.string,
  suggestedMail: PropTypes.string.isRequired,
  updatedList: PropTypes.array.isRequired,
  variant: PropTypes.string.isRequired,
};

export default WelcomePageLayouts;
